import React from 'react';
import styled from 'styled-components';
import {swirl, brown} from '@styles/colors';
import {media} from '@styles';
import Line from '@components/Line';
import {tisapro, franklinGothic} from '@styles/fonts';

type IconTypes = React.PropsWithChildren<{
  title?: string;
  caption?: string;
  className?: string;
  line?: boolean;
}>;

const IconContainer = styled.div<{}>`
  display: flex;
  justify-content: center;
`;

const IconCardTitle = styled.h3<{caption?: boolean}>`
  font-size: 1.5rem;
  font-weight: bold;
  text-transform: uppercase;
  font-family: ${franklinGothic};
  color: ${brown};
  text-align: center;
  padding: 25px 0;

  ${media.tablet`
    font-size: 1.125rem;
    line-height: 1.5625rem;
    padding: 18px 0;
  `}
`;

const IconCardParagraph = styled.p`
  font-size: 1rem;
  line-height: 1.5625rem;
  font-family: ${tisapro};
  color: ${brown};
  text-align: center;
  padding: 25px 0;
`;

const IconCard = (props: IconTypes): JSX.Element => {
  const {caption, className, children, title, line} = props;

  return (
    <div className={className}>
      <div>
        <IconContainer>{children}</IconContainer>
        <IconCardTitle>{title}</IconCardTitle>
      </div>
      {line ? <Line align="center" width="80%" /> : null}
      {caption ? <IconCardParagraph>{caption}</IconCardParagraph> : null}
    </div>
  );
};

export default IconCard;
